import { useCookieConsent } from '../../contexts/CookieConsentContext';
import { Link } from 'react-router-dom';

export default function CookieBanner() {
  const { showBanner, acceptAll, rejectAll, openSettingsModal } = useCookieConsent();

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[9999] animate-slideUp">
      <div className="mx-auto max-w-7xl px-4 pb-4 sm:px-6 lg:px-8">
        <div className="rounded-2xl bg-gray-900 p-6 shadow-2xl">
          <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
            <div className="flex-1">
              <h3 className="mb-2 text-lg font-semibold text-white">
                Çerez Tercihleri
              </h3>
              <p className="mb-3 text-sm leading-relaxed text-gray-300">
                Web sitemizin düzgün çalışması için zorunlu çerezleri kullanıyoruz. Analitik ve pazarlama çerezleri, hizmet kalitesini artırmak ve içerikleri geliştirmek için kullanılabilir. Tercihlerinizi dilediğiniz zaman değiştirebilirsiniz.
              </p>
              <div className="flex flex-wrap gap-3 text-sm">
                <Link
                  to="/cerez-politikasi"
                  className="text-blue-400 underline hover:text-blue-300 transition-colors whitespace-nowrap"
                >
                  Çerez Politikası
                </Link>
                <Link
                  to="/kvkk"
                  className="text-blue-400 underline hover:text-blue-300 transition-colors whitespace-nowrap"
                >
                  Aydınlatma Metni (KVKK)
                </Link>
              </div>
            </div>

            <div className="flex flex-col gap-2 sm:flex-row lg:flex-col xl:flex-row">
              <button
                onClick={acceptAll}
                className="whitespace-nowrap rounded-lg bg-blue-600 px-6 py-2.5 text-sm font-medium text-white hover:bg-blue-700 active:scale-98 transition-all duration-140 shadow-lg hover:shadow-xl cursor-pointer"
              >
                Tümünü Kabul Et
              </button>
              <button
                onClick={rejectAll}
                className="whitespace-nowrap rounded-lg bg-gray-700 px-6 py-2.5 text-sm font-medium text-white hover:bg-gray-600 active:scale-98 transition-all duration-140 cursor-pointer"
              >
                Reddet
              </button>
              <button
                onClick={openSettingsModal}
                className="whitespace-nowrap rounded-lg border-2 border-gray-600 bg-transparent px-6 py-2.5 text-sm font-medium text-white hover:border-gray-500 hover:bg-gray-800 active:scale-98 transition-all duration-140 cursor-pointer"
              >
                Tercihleri Yönet
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}